"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var Filter = /*#__PURE__*/function () {
  function Filter() {
    (0, _classCallCheck2["default"])(this, Filter);
  }

  (0, _createClass2["default"])(Filter, [{
    key: "getName",
    value: function getName() {
      throw new Error('Sub-class of Filter must implement getName method.');
    }
  }, {
    key: "getValue",
    value: function getValue() {
      throw new Error('Sub-class of Filter must implement getValue method.');
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      throw new Error('Sub-class of Filter must implement toJSON method.');
    }
  }, {
    key: "toString",
    value: function toString() {
      throw new Error('Sub-class of Filter must implement toString method.');
    }
  }, {
    key: "toCanvasString",
    value: function toCanvasString() {
      throw new Error('Sub-class of Filter must implement toCanvasString method.');
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(inJSON) {
      // eslint-disable-line no-unused-vars
      throw new Error('Sub-class of Filter must implement fromJSON method.');
    }
    /**
     * Checks if object is an instance of Filter
     *
     * @param inputObject
     * @returns {boolean}
     */

  }, {
    key: "isFilter",
    value: function isFilter(inputObject) {
      return inputObject instanceof Filter || inputObject && inputObject.prototype instanceof Filter;
    }
  }]);
  return Filter;
}();

exports["default"] = Filter;
(0, _defineProperty2["default"])(Filter, "NONE", 'none');